import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./TeacherInfo.css";

export default function WaitingApproval() {
    const { t } = useTranslation();
    return (
        <div className="tw-page">
            <div className="container">
                <div className="tw-wait tw-card">
                    <div className="tw-card-body">
                        <span className="tw-wait-icon"><i className="fa-light fa-hourglass-half" aria-hidden="true" /></span>
                        <h2>{t("waitingApproval.thank_you")}</h2>
                        <p className="tw-wait-lead">{t("waitingApproval.application_received")}</p>

                        <ol className="tw-timeline">
                            <li className="is-done">
                                <span className="tw-timeline-dot"><i className="fa-solid fa-check" aria-hidden="true" /></span>
                                <div>
                                    <div className="tw-timeline-title">{t("waitingApproval.step_submitted")}</div>
                                    <div className="tw-timeline-sub">{t("waitingApproval.step_submitted_sub")}</div>
                                </div>
                            </li>
                            <li className="is-current" aria-current="step">
                                <span className="tw-timeline-dot"><i className="fa-solid fa-magnifying-glass" aria-hidden="true" /></span>
                                <div>
                                    <div className="tw-timeline-title">{t("waitingApproval.step_review")}</div>
                                    <div className="tw-timeline-sub">{t("waitingApproval.step_review_sub")}</div>
                                </div>
                            </li>
                            <li>
                                <span className="tw-timeline-dot"><i className="fa-solid fa-chalkboard-user" aria-hidden="true" /></span>
                                <div>
                                    <div className="tw-timeline-title">{t("waitingApproval.step_teach")}</div>
                                    <div className="tw-timeline-sub">{t("waitingApproval.step_teach_sub")}</div>
                                </div>
                            </li>
                        </ol>

                        <Link to="/" className="tw-btn tw-btn-ghost">
                            <i className="fa-light fa-house" aria-hidden="true" /> {t("waitingApproval.back_home")}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
